import React, { useMemo } from 'react'
import { ErfResponse } from '../../../api/bridgingFinance/searchPropertyByErf'
import { EmptyMessage } from '../../kyc/EmptyMessage'
import '../SearchResultsTable.css'

export interface PropertyTableProps {
  entries?: ErfResponse[] | null
  title: string
  onRowClick?: (row: ErfResponse) => void
}

export const SearchByErfNoResultsTable: React.FC<PropertyTableProps> = ({
  entries,
  title,
  onRowClick,
}) => {
  const handleClick = (erf: ErfResponse) => () => {
    if (onRowClick) onRowClick(erf)
  }

  const showEmpty = useMemo(() => !entries, [entries])
  if (entries === undefined) return null

  return (
    <div className="kyc-bf-results-table-container">
      <h3 className="table-title">{title}</h3>
      <table>
        <thead>
          <tr style={{ height: '40px' }}>
            <th style={{ width: '70px' }}>Erf No</th>
            <th style={{ width: '70px' }}>Street No</th>
            <th>Township</th>
            <th>Address</th>
            <th>Suburb</th>
            <th>Municipality Name</th>
            {/* <th>Allotment</th>
          <th>CMA ID</th> */}
          </tr>
        </thead>
        <tbody>
          {showEmpty && <EmptyMessage />}
          {entries?.map((entry, index) => (
            <tr
              key={index}
              onClick={handleClick(entry)}
              style={{ height: '30px' }}
            >
              <td style={{ width: '70px' }}>{entry.erfNo}</td>
              <td style={{ width: '70px' }}>{entry.streetNo}</td>
              <td>{entry.allotment}</td>
              <td>{entry.address}</td>
              <td>{entry.suburb}</td>
              <td>{entry.mun_name || '-'}</td>
              {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
